import RestaurantPlanList from "./RestaurantPlanList";
// import RestaurantPlanEdit from "./RestaurantPlanEdit";
// import RestaurantPlanShow from "./RestaurantPlanShow";
import RestaurantPlanIcon from "@mui/icons-material/AttachMoney";

const restaurantPlans = {
  list: RestaurantPlanList,
  // edit: RestaurantPlanEdit,
  // show: RestaurantPlanShow,
  icon: RestaurantPlanIcon,
};

export default restaurantPlans;
